/* src/app/components/model-group-characteristics/model-group-characteristics.component.scss */
/*# sourceMappingURL=model-group-characteristics.component.css.map */
